import React from 'react';
import ReactDOM from 'react-dom/client';

import '@fontsource/inter';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const enableMocking = async () => {
    if (process.env.REACT_APP_ENABLE_MSW !== 'true') {
        return;
    }

    const { worker } = await import('./mocks/browser');
    await worker.start({
        onUnhandledRequest(request, print) {
            if (new URL(request.url).pathname.startsWith('/api/')) {
                print.error();
            }
        },
        serviceWorker: {
            url: '/mockServiceWorker.js',
        },
    });
};

enableMocking().then(() => {
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
}).catch((error: unknown) => {
    // eslint-disable-next-line no-console
    console.error('Nie udało się uruchomić mocków API.', error);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
